import React from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

export default function PopupConfirm({ label, className, onConfirm, message }) {
  return (
    <Popup
      className={className}
      trigger={<button className={className}>{label}</button>}
      modal
      nested
    >
      {close => (
        <div className="modal">
          <div className="header">{message}</div>
          <div className="actions">
            <button
              className="yes-button"
              onClick={() => {
                onConfirm();
                close();
              }}
            >
              Yes
            </button>
            <button className="no-button" onClick={close}>
              No
            </button>
          </div>
        </div>
      )}
    </Popup>
  );
}
